import React from "react";
import FancyThanks from "@/components/FancyThanks";

/**
 * v1.25.52 — Customer-side full-screen "THANK YOU" celebration after a
 * successful slip upload. Now uses the shared FancyThanks primitive
 * (3D gold text + flying shards + confetti + sparkle sweep) so it looks
 * as premium as the pixabay reference the admin asked for.
 */
export default function ThanksOverlay({ open, onClose, count = 1, kind = "slip", meta = null }) {
    // v1.25.70 — Overlay copy now matches the actual event. Was hardcoded
    // to slip-upload wording, so admin payouts wrongly showed
    // "Your slip is uploaded — sit back while we verify" on customer phones.
    if (kind === "payout") {
        const amt = meta && typeof meta.amount === "number" ? meta.amount : null;
        return (
            <FancyThanks
                open={open}
                onClose={onClose}
                title="PAYMENT RECEIVED"
                subtitle={amt != null ? `₹${amt.toLocaleString("en-IN")} has been paid to you.` : "MICM has paid you."}
                caption="The credit has been posted to your ledger. Tap Done to view it."
                ctaLabel="See ledger"
                palette="teal"
                testId="thanks-overlay-payout"
            />
        );
    }
    if (kind === "verified") {
        const amt = meta && typeof meta.amount === "number" ? meta.amount : null;
        return (
            <FancyThanks
                open={open}
                onClose={onClose}
                title="PAYMENT VERIFIED"
                subtitle={amt != null ? `₹${amt.toLocaleString("en-IN")} has been verified and credited.` : "Your payment has been verified."}
                caption="You'll see it reflected in your ledger balance."
                ctaLabel="See ledger"
                palette="gold"
                testId="thanks-overlay-verified"
            />
        );
    }
    // Default: slip upload (unchanged wording).
    return (
        <FancyThanks
            open={open}
            onClose={onClose}
            title="THANK YOU"
            subtitle={count > 1
                ? `${count} slips uploaded — sit back while we verify.`
                : "Your slip is uploaded — sit back while we verify."}
            caption="You'll see the credit on your ledger as soon as it's verified."
            ctaLabel="Done"
            palette="gold"
            testId="thanks-overlay"
        />
    );
}
